import { Pressable, Text, styles, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import * as style from '../Booking.module.css';

const RoomCard = ({ className, image, occupation, onPress, plan, rate, selected = false, testId, title }) => {
  const Container = onPress ? Pressable : View;

  return (
    <Container
      className={styles(style.option, selected && style.optionSelected, className)}
      {...(onPress ? { onPress } : undefined)}
      testId={testId}
    >
      <View row className={style.optionContent}>
        <View
          aria-label={title}
          role="img"
          className={style.optionImage}
          style={image ? { backgroundImage: `url(${image})` } : undefined}
        />
        <View className={style.optionDetails}>
          <Text action bold>
            {title}
          </Text>
          {rate ? <Text small>{rate}</Text> : undefined}
          {occupation ? <Text small>{occupation}</Text> : undefined}
          {plan ? <Text small>{plan}</Text> : undefined}
        </View>
      </View>
    </Container>
  );
};

RoomCard.displayName = 'Mirai:Core:Booking:RoomCard';

RoomCard.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string,
  occupation: PropTypes.string,
  onPress: PropTypes.func,
  plan: PropTypes.string,
  rate: PropTypes.string,
  selected: PropTypes.bool,
  testId: PropTypes.string,
  title: PropTypes.string,
};

export { RoomCard };
